// extracted by mini-css-extract-plugin
module.exports = {"events":"calendar_events__p_Ka9","summits":"calendar_summits__si4Fk"};